module.exports = __webpack_public_path__ + "static/media/errorIcon.43fc7843.svg";